/* GENERATED by scripts/gen-data.mjs — chapter "x-contracts" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_X_CONTRACTS: NodeDef = {
  "id": "x-contracts",
  "tagKey": "path:x-contracts.tag",
  "x": 96,
  "y": 440,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-contracts.title",
  "subKey": "path:x-contracts.sub",
  "blocks": [
    {
      "id": "x-contracts.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-contracts.b1.title",
      "bodyKey": "path:x-contracts.b1.body",
      "flowKey": "path:x-contracts.b1.flow"
    },
    {
      "id": "x-contracts.b2",
      "kind": "tree",
      "xp": 20,
      "titleKey": "path:x-contracts.b2.title",
      "tree": {
        "qKey": "path:x-contracts.b2.tree.q",
        "branches": [
          {
            "tone": "pass",
            "aKey": "path:x-contracts.b2.tree.b.0.a",
            "verdictKey": "path:x-contracts.b2.tree.b.0.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:x-contracts.b2.tree.b.1.a",
            "verdictKey": "path:x-contracts.b2.tree.b.1.verdict"
          },
          {
            "tone": "stop",
            "aKey": "path:x-contracts.b2.tree.b.2.a",
            "verdictKey": "path:x-contracts.b2.tree.b.2.verdict"
          }
        ]
      }
    },
    {
      "id": "x-contracts.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-contracts.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-contracts.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-contracts.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-contracts.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-contracts.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-contracts.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-contracts.b3.ex.options.2.fb"
          },
          {
            "tKey": "path:x-contracts.b3.ex.options.3.t",
            "ok": false,
            "fbKey": "path:x-contracts.b3.ex.options.3.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "service-split"
};
